import * as _ from 'lodash';
import { AbsenceType } from './AbsenceType';
import { Access } from './Access';
import { AllergiesType } from './Allergies';
import { AmputationTypes } from './Amputation';
import { AquaBoolean } from './AquaBoolean';
import { AquaErrorIdentifier } from './AquaErrorIdentifier';
import { AquaFixationType } from './AquaFixationType';
import { AquaType } from './AquaType';
import { AquaValidationType } from './AquaValidationType';
import { AquaVersionType, getAquaVersion } from './AquaVersionType';
import { BaseDataGeneralType } from './BaseDataGeneralType';
import { BaseDataKvType } from './BaseDataKvType';
import { BaseDataReferenceCareType } from './BaseDataReferenceCareType';
import { BooleanType } from './BooleanType';
import { CarePeriodCareType } from './CarePeriodCareType';
import {
  ConsciousnessState,
  FixationFrequency,
  TubeApplicationType,
  WeightControlDecisionType,
} from './CarePlan';
import { ConsultingGeneralType } from './ConsultingGeneralType';
import { DeadlinePeriodType } from './DeadlinePeriodType';
import { DecubitusStadium } from './DecubitusStadium';
import { DocumentationType } from './DocumentationType';
import { DocumentTemplateType } from './DocumentTemplate';
import { EmailTemplateType } from './EmailTemplateType';
import { EmployeeBaseDataType } from './EmployeeBaseDataType';
import { ErrorCode } from './ErrorCode';
import { ExecutionProofType } from './ExecutionProofType';
import { ExternalInformationType } from './ExternalInformationType';
import { FallEmergence } from './FallEmergence';
import { FibuExportType } from './FibuExportType';
import { FileType } from './FileType';
import { FootSyndromGrade } from './FootSyndromGrade';
import { Gender } from './Gender';
import { HintsConfigType } from './HintsConfigType';
import { HintType } from './HintType';
import { HouseDivisionType } from './HouseDivision';
import { InstitutionState } from './institution-state';
import { IntervalType } from './IntervalType';
import { MealType } from './MealType';
import { MovementColor } from './MovementColor';
import { NursingOverviewType } from './NursingOverviewType';
import { NursingTaskType } from './NursingTaskType';
import { PackageSize } from './PackageSize';
import { PainType } from './Pain';
import { Rating } from './Rating';
import { Risk } from './Risk';
import { RiskListType } from './RiskListType';
import { ShiftType } from './ShiftType';
import { TaskDocumentationSkipType } from './TaskDocumentationSkipType';
import { TaskDocumentationState } from './TaskDocumentationState';
import { TimeZone } from './TimeZone';
import { UlcusGrade } from './UlcusGrade';
import { VitalSignTypes } from './VitalSignTypes';
import { Weekdays } from './Weekdays';
import { WeightChangeMeasures } from './WeightChangeMeasures';
import { WeightChangeReasons } from './WeightChangeReasons';
import { WeightOutOfRangeType } from './WeightOutOfRangeType';
import { WoundDescriptionType } from './WoundDescription';
import { WoundEmergence } from './WoundEmergence';
import { WoundType } from './WoundType';

/**
 * Type to retrieve entries of an enum
 */
export type ValueOf<T> = T[keyof T];

/**
 * Returns all values of an enum as list of string.
 *
 * @param {Object} anEnum any enum
 * @return {unknown[]} a list of all values of the enum
 */
function values<T extends object>(anEnum: T): ValueOf<T>[] {
  return Object.values(_.forIn(anEnum, (_, value) => value)); // modify enum to only left the actual values
}

/**
 * Returns all values of an enum as list of numbers.
 *
 * @param {Object} anEnum any enum
 * @return {number[]} a list of all values of the enum
 */
function numbers<T extends object>(anEnum: T): number[] {
  return Object.values(_.forIn(anEnum, (_, value) => value)).filter(
    (elem) => typeof elem == 'number', // remove everything that's not a number
  ) as number[];
}

export * from './AquaScales';
export * from './Weekdays';
export {
  Access,
  Rating,
  Risk,
  TimeZone,
  numbers,
  values,
  FallEmergence,
  WoundType,
  WoundEmergence,
  WoundDescriptionType,
  DecubitusStadium,
  Gender,
  HouseDivisionType,
  ErrorCode,
  NursingTaskType,
  ExecutionProofType,
  TaskDocumentationState,
  Weekdays,
  VitalSignTypes,
  AmputationTypes,
  AllergiesType,
  MealType,
  CarePeriodCareType,
  PackageSize,
  AbsenceType,
  ShiftType,
  FixationFrequency,
  TubeApplicationType,
  WeightControlDecisionType,
  ConsciousnessState,
  DocumentationType,
  IntervalType,
  UlcusGrade,
  FootSyndromGrade,
  BooleanType,
  MovementColor,
  AquaType,
  AquaBoolean,
  AquaFixationType,
  NursingOverviewType,
  EmployeeBaseDataType,
  BaseDataGeneralType,
  BaseDataKvType,
  ConsultingGeneralType,
  RiskListType,
  WeightOutOfRangeType,
  WeightChangeReasons,
  WeightChangeMeasures,
  AquaValidationType,
  TaskDocumentationSkipType,
  PainType,
  DeadlinePeriodType,
  HintType,
  HintsConfigType,
  FileType,
  AquaErrorIdentifier,
  InstitutionState,
  BaseDataReferenceCareType,
  FibuExportType,
  AquaVersionType,
  DocumentTemplateType,
  getAquaVersion,
  EmailTemplateType,
  ExternalInformationType,
};
